module.exports = "/virtual-football-league/img/amblems/right/logos/ManchesterCity.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/ManchesterCity.png
// module id = 2214
// module chunks = 4